import React from "react";
import {Button, makeStyles, Text, tokens} from "@fluentui/react-components";
import {ArrowClockwise16Regular, ErrorCircle24Regular} from "@fluentui/react-icons";
import {useTranslation} from "react-i18next";

interface ErrorViewProps {
    error: unknown;
    onRetry?: () => void;
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: tokens.spacingVerticalS,
        padding: tokens.spacingVerticalL,
        borderRadius: tokens.borderRadiusMedium,
        border: `1px solid ${tokens.colorPaletteRedBorder2}`,
        backgroundColor: tokens.colorPaletteRedBackground1,
        textAlign: 'center',
        width: '100%',
        boxSizing: 'border-box'
    },
    title: {
        color: tokens.colorPaletteRedForeground1,
    },
    message: {
        color: tokens.colorNeutralForeground3,
    },
});

export default function ErrorView({error, onRetry}: Readonly<ErrorViewProps>) {
    const {t} = useTranslation();
    const styles = useStyles();

    if (error instanceof Error) {
        return <div className={styles.container}>
            <ErrorCircle24Regular color={tokens.colorPaletteRedForeground1}/>

            <Text weight="semibold" size={300} className={styles.title}>
                {t("translation:general.error")}
            </Text>

            {
                error &&
                <Text size={200} className={styles.message}>
                    {getMessage(error)}
                </Text>
            }

            {onRetry && (
                <Button appearance="outline" size="small" onClick={onRetry} icon={<ArrowClockwise16Regular/>}>
                    {t("translation:general.retry")}
                </Button>
            )}
        </div>
    }


    if (error instanceof String) {
        return <div>{error}</div>
    }

    return (<div></div>)
}

function getMessage(error: unknown): string {
    if (error instanceof Error) {
        return (error.name.toLowerCase() !== 'error' ? `${error.name}: ` : '') + error.message;
    } else if (typeof error === 'string') {
        return error;
    } else {
        return "";
    }
}